import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { ensurePermissions } from '@/hooks/usePermissions';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/constants-mapping',
)({
  // The layout route for all three tabs, so the feature and the read
  // permission are asked once here rather than on each — and a typed URL
  // cannot slip past them. Mind the two spellings: `constants-mapping` is the
  // platform feature, `constant-mapping` the IAM resource.
  beforeLoad: async () => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!hasFeature(user, 'constants-mapping')) {
      throw redirect({ to: '/company-settings/users' });
    }

    const perms = await ensurePermissions();
    if (!perms['constant-mapping'].canRead) {
      throw redirect({ to: '/company-settings/users' });
    }
  },
  component: ConstantsMappingLayout,
});

// No tab bar of its own anymore — Materials/Product Types/Facility Processes moved
// into the Company Settings tab bar's own "Constants Mapping" dropdown
// (`company-settings/(pages)/route.tsx`), which is what now switches between
// them. This layout is left owning only the permission gate above.
function ConstantsMappingLayout() {
  return (
    <PageContainer>
      <Outlet />
    </PageContainer>
  );
}
